import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ConnectorService } from './connector.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class NewsService {

  constructor(private http: HttpClient, private connector: ConnectorService) {}

  private news: string[] = [];
  private news$ = new BehaviorSubject<string[]>([]);

  private buildHeaders() {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+ this.connector.token()
      }
    };
  }

  setNews(news: string[]) {
    this.news = [...news];
    this.news$.next(this.news);
  }
  
  getLatestNews(): string[] {
    return this.news;
  }

  getNews$(): Observable<string[]> {
    return this.news$.asObservable();
  }
}
